import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const home = () => import("./../views/home/index");
const result = () => import("./../views/result/index");
const detail = () => import("./../views/detail/index");
const routes = [
  {
    path: "/",
    // redirect: "/home",默认调整为列表页 chenss 20230407
    redirect: "/result",
  },
  {
    path: "/home",
    name: "home",
    component: home,
    meta: {
      title: "首页",
    },
  },
  {
    path: "/result",
    name: "result",
    component: result,
    meta: {
      title: "搜索结果",
    },
  },
  {
    path: "/detail/:id",
    name: "detail",
    component: detail,
    meta: {
      title: "详情",
    },
  },
];

const router = new Router({
  routes,
  scrollBehavior() {
    return {x: 0, y: 0};
  }
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};


export default router;
